import { render, staticRenderFns } from "./TabsContainer.vue?vue&type=template&id=55644d3e&"
import script from "./TabsContainer.vue?vue&type=script&lang=js&"
export * from "./TabsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports